import { render, staticRenderFns } from "./badminton_common.vue?vue&type=template&id=79595586"
import script from "./badminton_common.vue?vue&type=script&lang=js"
export * from "./badminton_common.vue?vue&type=script&lang=js"
import style0 from "./badminton_common.vue?vue&type=style&index=0&id=79595586&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports